import { Component, OnInit, TemplateRef } from '@angular/core';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { G_TagsViewModel } from 'src/app/viewmodels/g-settings/G_TagsViewModel';
import { G_TagsTypeViewModel } from 'src/app/viewmodels/g-settings/G_TagsTypeViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { NgxSpinnerService } from 'ngx-spinner';
import { SaveTagRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss']
})
export class TagsComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  public itemVm: SaveTagRequest = new SaveTagRequest();
  // public tagtypeVm: G_TagsTypeViewModel = new G_TagsTypeViewModel();
  public vmListItems: any = [];
  public tagTypes: any = [];
  public component_Title = "Tag";
  public deleteId: string;

  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.spinner.show();
    this.getList();
    this.getTagTypes();
    setTimeout(() => {
      this.spinner.hide();
    }, 500);
  }
  getTagTypes() {
    this._jq.showSpinner(true);
    this._uow.gSettingService.GetTagTypesAsync().subscribe((res: any) =>
    {
      this.tagTypes = res.result;
    this._jq.showSpinner();
   },
    (err) => console.log(err));
  }

  openModal(template: TemplateRef<any>, lvl: number) {
    if (lvl == 1) {
      this.modalRefLv1 = this._modalService.show(template);
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
  }

  ngAfterViewInit() {
    // this._jq.showSpinner();
  }

  getList() {
    this._jq.showSpinner(true);
    this._uow.gSettingService.GetTagsAsync().subscribe((res: any) => {
      this._jq.reinitDataTable(res.result);
      this.vmListItems = res.result;
      this._jq.showSpinner();
    }, (err) => {
      console.log(err);
    });
  }



  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
      console.log(this.itemVm)
      this.itemVm.tagType = new ItemViewModel1(model.tagType.id,model.tagType.name);
    } else {
      this.itemVm = new SaveTagRequest();
    }
  }
   // extrnal components
   onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.itemVm = new SaveTagRequest();
      this.getList();
    }
  }

  openDeleteModel(template: TemplateRef<any>, model?) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    this._uow.gSettingService.DeleteTagAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRefLv1.hide();
    }, (err) => {
      this._jq.showSpinner();
    });
  }

}
